function helperNewDate () {
  return new Date()
}

module.exports = helperNewDate



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/date/helperNewDate.js
// module id = /fcJ
// module chunks = 94